import React from 'react'
import PropTypes from 'prop-types'
import { List, Map } from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { CONTENT_IMAGE_TYPE_POSTER_3X4 } from '../../../services/content/index'
import { getMetaImageUrls } from '../../DetailPageV3/utils'
import Check from '../../Icon/icons/Check/index'

function OnboardingAddToPlaylistTile (props) {
  const {
    tile,
    isSelected,
    onToggleSelected,
  } = props

  const contentId = tile.get('contentId')
  const images = tile.get('images', List()) || List()
  const imageData = images.find((img) => img.get('type') === CONTENT_IMAGE_TYPE_POSTER_3X4) || Map()
  const { fallbackImageUrl, imageUrl } = getMetaImageUrls(imageData.get('url'), 385, 513)
  const title = tile.get('title') || ''

  const thumbWrapClass = isSelected
    ? 'onboarding-add-to-playlist__thumb-wrap onboarding-add-to-playlist__thumb-wrap--selected'
    : 'onboarding-add-to-playlist__thumb-wrap'

  return (
    <button
      type="button"
      className="onboarding-add-to-playlist__tile"
      onClick={() => onToggleSelected(contentId)}
    >
      <span className={thumbWrapClass}>
        {imageUrl || fallbackImageUrl ? (
          <span
            className="onboarding-add-to-playlist__thumb"
            style={{ backgroundImage: `url(${imageUrl || fallbackImageUrl})` }}
          />
        ) : (
          <span className="onboarding-add-to-playlist__thumb onboarding-add-to-playlist__thumb--placeholder" />
        )}
        {isSelected ? (
          <span className="onboarding-add-to-playlist__check">
            <Check color="#ffffff"/>
          </span>
        ) : null}
      </span>
      <span className="onboarding-add-to-playlist__tile-title">{title}</span>
    </button>
  )
}

OnboardingAddToPlaylistTile.propTypes = {
  tile: ImmutablePropTypes.map.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggleSelected: PropTypes.func.isRequired,
}

export default OnboardingAddToPlaylistTile
